import React from 'react';
import { useLocation } from 'react-router-dom';
import useSEO from '../hooks/useSEO';
import MarketingLayout from '../components/MarketingLayout';
import MembershipSelection from '../components/MembershipSelection';

const MembershipPage = () => {
  useSEO({
    title: 'Membership - APDoneRight',
    description:
      'Choose a plan and unlock course-aware tutoring, flashcards, and planning across your AP subjects with a 3-day free trial.',
    canonical: '/membership',
    robots: 'noindex,follow',
    openGraph: {
      title: 'Membership - APDoneRight',
      description:
        'Unlock course-aware tutoring, flashcards, and planning across your AP subjects with a 3-day free trial.',
    },
  });

  const location = useLocation();
  const fromPath = location?.state?.from?.pathname || null;
  const message = location?.state?.message || '';

  return (
    <MarketingLayout
      showNavbar={false}
      showFooter={false}
      className="ap-membership-layout"
      mainClassName="ap-membership-layout-main"
    >
      <MembershipSelection
        fromPath={fromPath}
        message={message}
        onboardingContext={location?.state?.onboardingContext || null}
      />
    </MarketingLayout>
  );
};

export default MembershipPage;
